import { ListItemLabel } from "baseui/list";
import { BacnetObjectMappingConfiguration, useGetMappingsFromObjectIdQuery } from "../../../../services/mapping/bacnet";
import { SpecialEventCalendarReferencePeriod } from "../../../../services/schedulers/types";
import { IScheduler } from "../types";
import { HierarchyObjectNavigation } from "../../../../components/HierarchyNavigation";
import { useGetObjectByIdQuery } from "../../../../services/objects";
import { LoadingView } from "../../../../components";
import { useGetBacnetObjectMappingsByObject } from "../../../../hooks/useGetBacnetMappings";


export const CalendarRefListItem = (props: { eventPriority: number, period: SpecialEventCalendarReferencePeriod, app: IScheduler }) => {
  const { period, app, eventPriority } = props;

  // we already know it
  if (period.twinId && period.twinResourceGroupId)
    return (<CalendarRefListRealObject eventPriority={eventPriority} app={app} objectId={period.twinId} resourceGroupId={period.twinResourceGroupId} period={period}   ></CalendarRefListRealObject>)

  return <CalendarReferenceBacnetObject eventPriority={eventPriority} app={app} period={period} ></CalendarReferenceBacnetObject>
}

const CalendarReferenceBacnetObject = (props: { app: IScheduler, eventPriority: number, period: SpecialEventCalendarReferencePeriod, }) => {
  const { app, eventPriority, period } = props;
  // 1st we need to get a mapping from our app to know the edge device
  const { data: myMappings, isSuccess, isLoading, error } = useGetMappingsFromObjectIdQuery(app.id);

  const firstMapping = (myMappings && myMappings.length > 0) ? myMappings[0] : undefined;
  return (
    <LoadingView rows={1} isLoading={isLoading} isSucess={isSuccess} error={error}>
      {firstMapping ?
        <CalendarRefListItemRootMapping eventPriority={eventPriority} app={app} period={period} rootMapping={firstMapping}></CalendarRefListItemRootMapping>
        :
        <ListItemLabel>Calendar: {JSON.stringify(period)}</ListItemLabel>
      }
    </LoadingView>
  )
}

const CalendarRefListItemRootMapping = (props: { eventPriority: number, period: SpecialEventCalendarReferencePeriod, app: IScheduler, rootMapping: BacnetObjectMappingConfiguration }) => {
  const { period, app, rootMapping, eventPriority } = props;
  const { objects: calendarMapping, isSuccess, isLoading, error } = useGetBacnetObjectMappingsByObject(rootMapping.deviceId, rootMapping.bACnetDeviceId, period.type, period.instanceId)

  const foundCalendarMapping = calendarMapping && calendarMapping?.length > 0 ? calendarMapping[0] : undefined

  return (
    <LoadingView rows={1} isLoading={isLoading} isSucess={isSuccess} error={error}>
      {foundCalendarMapping ?
        <CalendarRefListRealObject eventPriority={eventPriority} app={app} period={period} objectId={foundCalendarMapping.objectId} resourceGroupId={foundCalendarMapping.resourceGroupId}></CalendarRefListRealObject>
        :
        <ListItemLabel>Calendar: {JSON.stringify(period)}</ListItemLabel>
      }
    </LoadingView>)
}

const CalendarRefListRealObject = (props: { eventPriority: number, period: SpecialEventCalendarReferencePeriod, app: IScheduler, objectId: string, resourceGroupId: string }) => {
  const { period, app, eventPriority } = props;
  const { data: calendar, isSuccess, isLoading, error } = useGetObjectByIdQuery({ id: props.objectId, resourceGroupId: props.resourceGroupId })



  return (
    <LoadingView rows={1} isLoading={isLoading} isSucess={isSuccess} error={error}>
      {calendar ?
        <ListItemLabel
          overrides={{
            LabelContent: {
              style: ({ $theme }) => ({
                fontSize: $theme.typography.ParagraphSmall.fontSize
              })
            }
          }} description={`Priority: ${eventPriority}`}>
          <HierarchyObjectNavigation current={calendar.name} skip={1} currentAsLink currentDescription={calendar.description} showDescription objectId={calendar.id} resourceGroupId={calendar.resourceGroupId} ></HierarchyObjectNavigation>
        </ListItemLabel>
        :
        <ListItemLabel>Calendar: {JSON.stringify(period)}</ListItemLabel>
      }
    </LoadingView>
  )
}
